import React, { useLayoutEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { Loader2 } from "lucide-react";

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.mjs`;

export default function PdfViewer({ url }) {
  const containerRef = useRef(null);
  const [width, setWidth] = useState(0);
  const [numPages, setNumPages] = useState(0);
  const [error, setError] = useState(false);

  useLayoutEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const update = () => setWidth(el.clientWidth);
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  const pageWidth = width ? Math.min(width - 4, 900) : 0;

  return (
    <div
      ref={containerRef}
      className="w-full h-full overflow-y-auto overflow-x-hidden bg-cream rounded-xl py-4"
      onContextMenu={(e) => e.preventDefault()}
    >
      {error ? (
        <div className="w-full h-full flex items-center justify-center text-ink/60 font-body text-sm text-center px-6">
          No se pudo cargar el documento.
        </div>
      ) : pageWidth > 0 ? (
        <Document
          file={url}
          onLoadSuccess={({ numPages }) => setNumPages(numPages)}
          onLoadError={() => setError(true)}
          loading={
            <div className="w-full flex items-center justify-center py-16 text-plum/70">
              <Loader2 className="animate-spin" size={28} />
            </div>
          }
        >
          {Array.from({ length: numPages }, (_, i) => (
            <div key={i} className="mx-auto mb-4 shadow-md rounded overflow-hidden" style={{ width: pageWidth }}>
              <Page
                pageNumber={i + 1}
                width={pageWidth}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            </div>
          ))}
        </Document>
      ) : (
        <div className="w-full flex items-center justify-center py-16 text-plum/70">
          <Loader2 className="animate-spin" size={28} />
        </div>
      )}
    </div>
  );
}
